import { request } from '@/libs';

/**
 * 查询社招官网职能信息
 * 文档地址：http://yapi.manjuu.cn/project/65/interface/api/5807
 * */
export type JobCategory = {
  zhName: string;
  enName: string;
  jobCount: number;
  categoryId: string;
}[];

export const getJobCategory = async () => {
  return request<JobCategory>(`/oa-site/web/hire/listjobcategory`, {
    method: 'GET',
  });
};
